import revive_payload_client_4sVQNw7RlN from "/var/www/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/var/www/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/www/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/var/www/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/var/www/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_ghbUAjaD3n from "/var/www/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import plugin_client_OVoKJro5pc from "/var/www/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import plugin_client_LcKgStRyi6 from "/var/www/node_modules/nuxt-gtag/dist/runtime/plugin.client.mjs";
import chunk_reload_client_UciE0i6zes from "/var/www/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import blockly_client_eghvaFrO4W from "/var/www/plugins/blockly.client.ts";
import directive_I6YZ1QHKAO from "/var/www/plugins/directive.ts";
import game_client_uVFtfCYqNF from "/var/www/plugins/game.client.ts";
import markdownit_fsFV40uZ9C from "/var/www/plugins/markdownit.ts";
import sentry_client_shVUlIjFLk from "/var/www/plugins/sentry.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_ghbUAjaD3n,
  plugin_client_OVoKJro5pc,
  plugin_client_LcKgStRyi6,
  chunk_reload_client_UciE0i6zes,
  blockly_client_eghvaFrO4W,
  directive_I6YZ1QHKAO,
  game_client_uVFtfCYqNF,
  markdownit_fsFV40uZ9C,
  sentry_client_shVUlIjFLk
]